import React, { useEffect, useState } from "react";
import Api from "../Services/Api"; // ajuste o caminho se necessário

const DadosBacarios = () => {
  const [conta, setConta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    Api.get("/bank-accounts/me")
      .then((res) => {
        if (!mounted) return;
        setConta(res.data || null);
      })
      .catch(() => {
        if (!mounted) return;
        setConta(null);
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const formatBankName = (bank = "") => {
    return bank
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());
  };


  const banco = conta?.bank_name ? formatBankName(conta.bank_name) : "-";
  const agencia = conta?.branch ? String(conta.branch) : "-";

  const contaNumero = conta?.account_number ? String(conta.account_number) : "";
  const contaDigito = conta?.account_digit ? String(conta.account_digit) : "";
  const contaFormatada =
    contaNumero && contaDigito ? `${contaNumero}-${contaDigito}` : contaNumero || "-";

  return (
    <article className="card">
      <div className="card-header">
        <div className="card-title">
          <span>🏦</span>
          <span>Dados Bancários</span>
        </div>
      </div>

      <div className="card-body">
        {loading ? (
          <div>Carregando dados bancários...</div>
        ) : !conta ? (
          <>
            <div><strong>Banco:</strong> Não informado</div>
            <div><strong>Agência:</strong> -</div>
            <div><strong>Conta:</strong> -</div>
            <div className="card-sub">
              Você ainda não cadastrou seus dados. Preencha na tela de <strong>Dados bancários</strong>.
            </div>
          </>
        ) : (
          <>
            <div><strong>Banco:</strong> {banco}</div>
            <div><strong>Agência:</strong> {agencia}</div>
            <div><strong>Conta:</strong> {contaFormatada}</div>
            {conta?.pix_key ? (
              <div><strong>Pix:</strong> {conta.pix_key}</div>
            ) : null}

            <div className="card-sub">
              Alterações devem ser feitas na tela de <strong>Dados bancários</strong> no menu lateral.
            </div>
          </>
        )}
      </div>

      <div className="card-footer-inline">
        <a href="/dadosbancarios" className="inline-link">
          Ir para dados bancários
        </a>
      </div>
    </article>
  );
};

export default DadosBacarios;
